import { FaqSchema } from "@/components/FaqSchema";
import { ContentPageNav } from "@/components/ContentPageNav";
import { Footer } from "@/components/Footer";

const html = `<nav aria-label="Kruimelpad" class="px-3 pt-4 pb-2"><div class="container mx-auto max-w-6xl"><ol class="flex flex-wrap items-center gap-2 text-sm"><li class="flex items-center gap-2"><a href="/" class="text-muted-foreground hover:text-foreground transition-colors">Home</a></li><li class="text-foreground font-medium" aria-current="page">Jeugd-husselavond</li></ol></div></nav>

  <header class="py-10 md:py-20 px-3">
    <div class="container mx-auto max-w-3xl">
      <h1 class="text-3xl md:text-5xl font-bold text-foreground mb-6">Jeugd-husselavond organiseren bij je tennisclub</h1>
      <p class="text-lg md:text-xl text-muted-foreground leading-relaxed">De <strong>jeugd-husselavond</strong> is voor veel tennisclubs een belangrijk middel om jeugdleden vast te houden. Wisselende partners, korte rondes en de gezelligheid van samen tennissen. Maar de organisatie ervan kost commissies vaak veel tijd. Zo regel je het automatisch.</p>
    </div>
  </header>

  <article class="px-3 pb-6">
    <div class="container mx-auto max-w-3xl space-y-8">
      
        <section>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">Waarom een jeugd-husselavond?</h2>
          <div class="text-muted-foreground leading-relaxed space-y-4"><ul class="list-disc pl-6 space-y-1"><li>Jeugdleden leren elkaar over leeftijden heen kennen.</li><li>Variatie houdt het leuk — minder uitval.</li><li>Trainers kunnen meekijken voor talentontwikkeling.</li><li>Lage drempel: aanmelden, spelen, klaar.</li></ul></div>
        </section>
        <section>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">Aandachtspunten voor jeugd</h2>
          <div class="text-muted-foreground leading-relaxed space-y-4"><ol class="list-decimal pl-6 space-y-1"><li><strong>Korte rondes</strong> — 20-25 minuten houdt de aandacht erbij.</li><li><strong>Niveau-indeling strikter</strong> — verschil tussen 8 en 12 jaar is groot.</li><li><strong>Trainer of TC aanwezig</strong> — voor begeleiding en veiligheid.</li><li><strong>Aanmelden via ouders</strong> — koppel een ouder-account voor jongere kinderen.</li></ol></div>
        </section>
        <section>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">Hoe helpt De Hussel App?</h2>
          <div class="text-muted-foreground leading-relaxed space-y-4"><p>Het algoritme deelt jeugdspelers slim in op leeftijd en niveau. Push-meldingen helpen kinderen (en ouders) bij iedere ronde te weten op welke baan ze moeten staan — geen kind dat verloren langs de baan staat te wachten.</p><p>Privacy: minderjarige spelers worden gekoppeld aan een ouder/verzorger-account, en hun gegevens zijn alleen zichtbaar voor de club en hun teamgenoten.</p></div>
        </section>
    </div>
  </article>

  <section class="py-10 md:py-16 px-3">
    <div class="container mx-auto max-w-3xl">
      <div class="p-5 md:p-10 text-center rounded-lg border border-accent/30 bg-accent/10">
        <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">Klaar om dit voor je club te automatiseren?</h2>
        <p class="text-lg text-muted-foreground mb-6">De Hussel App regelt aanmelden, indelen en push-meldingen — voor husselen, tossen en racket trekken.</p>
        <a href="/club-register" class="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-accent text-accent-foreground font-medium hover:bg-accent/90 transition-colors">Registreer je club </a>
      </div>
    </div>
  </section>

  
  <section class="py-10 md:py-16 px-3">
    <div class="container mx-auto max-w-4xl">
      <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-6 md:mb-8 text-center">Veelgestelde vragen</h2>
      <div class="space-y-3">
    <details class="group rounded-lg border border-border bg-card p-4 md:p-5">
      <summary class="flex items-center justify-between gap-3 cursor-pointer list-none">
        <h3 class="text-base md:text-lg font-semibold text-foreground">Vanaf welke leeftijd is een husselavond geschikt?</h3>
        
      </summary>
      <div class="mt-3 text-muted-foreground leading-relaxed">Vanaf ongeveer 8 jaar, als kinderen het wedstrijdverloop begrijpen. Voor jongere kinderen werkt een tennislessenstructuur beter.</div>
    </details>
    <details class="group rounded-lg border border-border bg-card p-4 md:p-5">
      <summary class="flex items-center justify-between gap-3 cursor-pointer list-none">
        <h3 class="text-base md:text-lg font-semibold text-foreground">Mogen ouders meedoen?</h3>
        
      </summary>
      <div class="mt-3 text-muted-foreground leading-relaxed">Dat bepaalt de club zelf. Sommige verenigingen draaien een aparte ouder-kind hussel; de meeste houden jeugd en volwassenen gescheiden.</div>
    </details>
    <details class="group rounded-lg border border-border bg-card p-4 md:p-5">
      <summary class="flex items-center justify-between gap-3 cursor-pointer list-none">
        <h3 class="text-base md:text-lg font-semibold text-foreground">Hoe gaat de app om met minderjarigen?</h3>
        
      </summary>
      <div class="mt-3 text-muted-foreground leading-relaxed">Minderjarige spelers kunnen worden gekoppeld aan een ouder/verzorger-account. Gegevens zijn alleen zichtbaar voor club en teamgenoten — geen publieke profielen.</div>
    </details>
    <details class="group rounded-lg border border-border bg-card p-4 md:p-5">
      <summary class="flex items-center justify-between gap-3 cursor-pointer list-none">
        <h3 class="text-base md:text-lg font-semibold text-foreground">Is dit ook geschikt voor padel-jeugd?</h3>
        
      </summary>
      <div class="mt-3 text-muted-foreground leading-relaxed">Ja. De Hussel App werkt voor tennis én padel, en is daardoor ook geschikt voor jeugd-padel.</div>
    </details></div>
    </div>
  </section>`;

const JeugdHusselavondOrganiseren = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <ContentPageNav showPricing />
      <div
        className="flex-1 marketing-content"
        dangerouslySetInnerHTML={{ __html: html }}
      />
      <FaqSchema html={html} />
      <Footer />
    </div>
  );
};

export default JeugdHusselavondOrganiseren;
